import React from "react";
export const Tools = () => (
  <svg fill="none" viewBox="0 0 14 12">
    <path
      d="M13.3 10.25l-3.29-3.29-1.42 1.41 3.29 3.29c.39.39 1.03.39 1.41 0 .4-.39.4-1.02.01-1.41zM11.07 4.92c1.29 0 2.33-1.05 2.33-2.33 0-.39-.11-.75-.27-1.07l-1.8 1.8-.99-.99 1.8-1.8c-.32-.17-.68-.27-1.07-.27-1.29 0-2.33 1.05-2.33 2.33 0 .27.05.53.14.77L7.65 4.6 6.46 3.41c.26-.26.26-.68 0-.94L5.99 2 7.4.59c-.78-.78-2.05-.78-2.83 0L2.69 2.47c-.26.26-.26.68 0 .94l.47.47H1.47c-.13 0-.25.05-.33.14-.19.19-.19.48 0 .67l1.69 1.69c.19.19.48.19.67 0 .09-.08.14-.2.14-.33V4.36l.47.47c.26.26.68.26.94 0l1.19 1.19L2 10.24a.996.996 0 000 1.41c.39.39 1.03.39 1.41 0l6.88-6.87c.25.09.51.14.78.14z"
      fill="#192547"
    />
  </svg>
);
